module.exports = __webpack_public_path__ + "static/media/comingsoon.d7864ed2.png";